import { createContext, ReactNode, useEffect, useState } from "react";

type UserType = {
  token: string;
  authTime: number;
  exp: number;
  name: string;
  email: string;
  cnpj: string;
  instituicao_id: number;
  setToken: (newState: string) => void;
  setAuthTime: (newState: number) => void;
  setExp: (newState: number) => void;
  setName: (newState: string) => void;
  setEmail: (newState: string) => void;
  setCnpj: (newState: string) => void;
  setInstId: (newState: number) => void;
  isSessionValid: () => boolean;
};

const initialValue: UserType = {
  token: localStorage.getItem("token") || "",
  authTime: localStorage.getItem("authTime")
    ? Number(localStorage.getItem("authTime"))
    : 0,
  exp: localStorage.getItem("exp") ? Number(localStorage.getItem("exp")) : 0,
  name: localStorage.getItem("name") || "",
  email: localStorage.getItem("email") || "",
  cnpj: localStorage.getItem("cnpj") || "",
  instituicao_id: localStorage.getItem("instituicao_id")
    ? Number(localStorage.getItem("instituicao_id"))
    : -1,
  setToken: () => {},
  setAuthTime: () => {},
  setExp: () => {},
  setName: () => {},
  setEmail: () => {},
  setCnpj: () => {},
  setInstId: () => {},
  isSessionValid: () => false,
};

export const UserContext = createContext(initialValue);

type UserContextProps = {
  children: ReactNode;
};

export const UserContextProvider = ({ children }: UserContextProps) => {
  const [token, setToken] = useState(initialValue.token);
  const [authTime, setAuthTime] = useState(initialValue.authTime);
  const [exp, setExp] = useState(initialValue.exp);
  const [name, setName] = useState(initialValue.name);
  const [email, setEmail] = useState(initialValue.email);
  const [cnpj, setCnpj] = useState(initialValue.cnpj);
  const [instituicao_id, setInstId] = useState(initialValue.instituicao_id);

  useEffect(() => {
    localStorage.setItem("token", token);
    localStorage.setItem("authTime", `${authTime}`);
    localStorage.setItem("exp", `${exp}`);
    localStorage.setItem("name", name);
    localStorage.setItem("email", email);
    localStorage.setItem("cnpj", cnpj);
    localStorage.setItem("instituicao_id", `${instituicao_id}`);
  }, [token, authTime, exp, name, email, cnpj, instituicao_id]);

  return (
    <UserContext.Provider
      value={{
        token,
        authTime,
        exp,
        name,
        email,
        cnpj,
        instituicao_id,
        setToken,
        setAuthTime,
        setExp,
        setName,
        setEmail,
        setCnpj,
        setInstId,
        isSessionValid: () => {
          const timestamp = new Date().getTime();
          const diff = exp - timestamp;
          return diff > 0;
        },
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
